import React from 'react';
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md';

import colors from '~/styles/colors';

import TableData from '../../TableData';
import { BaseEntity, TableBodyProps } from '../interface';
import { CheckboxColumn, FirstColumn, RowData } from '../styles';
import TableMenu from '../TableMenu';

function TableRow<Entity extends BaseEntity>({
  entity,
  menu,
  columns,
  borderColor,
  selectedEntities,
}: TableBodyProps<Entity>) {
  const hasThisOption = (id: string) => {
    return (
      selectedEntities && selectedEntities[0].some((value) => id === value.id)
    );
  };

  const handleAddOption = (entity: Entity) => {
    if (!selectedEntities) return;

    const [values, setValues] = selectedEntities;

    setValues([...values, entity]);
  };

  const handleRemoveOption = (id: string) => {
    if (!selectedEntities) return;

    const [values, setValues] = selectedEntities;

    const newValue = values.filter((v) => v.id !== id);
    setValues(newValue);
  };

  return (
    <>
      <RowData key={entity.id} borderColor={borderColor}>
        {selectedEntities && (
          <CheckboxColumn>
            {hasThisOption(entity.id) ? (
              <MdCheckBox
                onClick={() => handleRemoveOption(entity.id)}
                size={24}
                color={colors.primary}
              />
            ) : (
              <MdCheckBoxOutlineBlank
                onClick={() => handleAddOption(entity)}
                size={24}
                color="#b4b4b4"
              />
            )}
          </CheckboxColumn>
        )}

        {!!borderColor && <FirstColumn borderColor={borderColor} />}

        {columns.map(
          (column) =>
            column.condition !== false && (
              <TableData>{column.value(entity)}</TableData>
            ),
        )}

        {menu && (
          <td>
            <TableMenu entity={entity} menus={menu} />
          </td>
        )}
      </RowData>
    </>
  );
}

export default TableRow;
